/** CMS-selectable friend challenge policy presets. */
export var FriendChallengePolicyTemplate;
(function (FriendChallengePolicyTemplate) {
    /** Strict: one open challenge, fewer invitees, no overlapping friend invites. */
    FriendChallengePolicyTemplate["A"] = "A";
    /** Moderate: multiple open challenges, more invitees, no overlapping friend invites. */
    FriendChallengePolicyTemplate["B"] = "B";
})(FriendChallengePolicyTemplate || (FriendChallengePolicyTemplate = {}));
export const FRIEND_CHALLENGE_POLICY_TEMPLATE_LABELS = {
    [FriendChallengePolicyTemplate.A]: 'A — Strict (Duolingo-like)',
    [FriendChallengePolicyTemplate.B]: 'B — Moderate',
};
export const FRIEND_CHALLENGE_POLICY_TEMPLATE_DEFAULTS = {
    [FriendChallengePolicyTemplate.A]: {
        maxOpenChallengesPerUser: 1,
        maxInviteesPerChallenge: 5,
        blockOverlappingFriendInvites: true,
    },
    [FriendChallengePolicyTemplate.B]: {
        maxOpenChallengesPerUser: 3,
        maxInviteesPerChallenge: 10,
        blockOverlappingFriendInvites: true,
    },
};
